import TaskDetails from './TaskDetails'
import localize from '../../higherOrderComponents/localize'

import { connect } from 'react-redux'
import { taskNameSave, taskDescriptionSave, taskAssignmentsSave } from '../../store/taskFields'
import { taskDelete } from '../../store/tasks'
import { commentAdd, commentDelete, commentsLoad } from '../../store/comments'
import { taskLinksLoad, taskLinksDeleteLink } from '../../store/taskLinks'
import {
  taskChecklistItemsLoad,
  taskChecklistItemsCreate,
  taskChecklistItemsSave,
  taskChecklistItemsDelete
} from '../../store/taskChecklistItems'
import keyBy from 'lodash/keyBy'

const mapStateToProps = (state, ownProps) => ({
  projectMembers: keyBy(state.projectMembers, 'id'),
  comments: state.comments[ownProps.task.id],
  taskLinks: state.taskLinks[ownProps.task.id],
  timeZone: state.userInfo.timeZone,
  taskChecklistItems: state.taskChecklistItems[ownProps.task.id]
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  addComment: (commentText) => { dispatch(commentAdd(ownProps.task.id, commentText)) },
  deleteComment: (commentId) => { dispatch(commentDelete(ownProps.task.id, commentId)) },
  deleteTaskLink: (linkId) => { dispatch(taskLinksDeleteLink(ownProps.task.id, linkId)) },
  loadComments: () => { dispatch(commentsLoad(ownProps.task.id)) },
  loadTaskLinks: () => { dispatch(taskLinksLoad(ownProps.task.id)) },
  loadTaskChecklistItems: () => { dispatch(taskChecklistItemsLoad(ownProps.task.id)) },
  createTaskChecklistItem: () => { dispatch(taskChecklistItemsCreate(ownProps.task.id)) },
  deleteTaskChecklistItem: (checklistItemId) => { dispatch(taskChecklistItemsDelete(ownProps.task.id, checklistItemId)) },
  saveTaskChecklistItem: (checklistItemId, name, checked) => {
    dispatch(taskChecklistItemsSave(ownProps.task.id, checklistItemId, name, checked))
  },
  saveName: (name, onError) => { dispatch(taskNameSave(ownProps.task.id, name, onError)) },
  saveDescription: (description, onError) => { dispatch(taskDescriptionSave(ownProps.task.id, description, onError)) },
  saveTaskAssignments: (assignments, onError) => { dispatch(taskAssignmentsSave(ownProps.task.id, assignments, onError)) },
  onDelete: (taskId, taskName) => { dispatch(taskDelete(taskId, taskName)) }
})

export default connect(mapStateToProps, mapDispatchToProps)(localize(TaskDetails))



// WEBPACK FOOTER //
// ./src/components/TaskDetails/index.js